import { handleAuthorization, handleOkResponseJson } from "./handlers"
import { obterToken } from "./loginService"
import * as axios from 'axios';

export default {
    obterGruposProdutoAsync,
    enviarGrupoProdutoAsync,
    editarGrupoProdutoAsync,
	downloadLista,
	obterSubGruposProdutoAsync,
    enviarSubGrupoProdutoAsync,
    editarSubGrupoProdutoAsync,
	downloadListaSubGrupoProduto
}

export const obterGruposProdutoAsync = async () => {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
    };
    return fetch(`${process.env.VUE_APP_API_URL}/GrupoProduto/obterLista`, requestOptions)
        .then(handleAuthorization)
        .then(handleOkResponseJson)
        .then(result => {
            return result.data;
        });
}

export const enviarGrupoProdutoAsync = async (descricao) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        body: JSON.stringify({ descricao })
    };
    return fetch(`${process.env.VUE_APP_API_URL}/GrupoProduto`, requestOptions)
        .then(handleAuthorization)
        .then(handleOkResponseJson)
        .then(result => {
            return result.data;
        });
}

export const editarGrupoProdutoAsync = async (id, descricao, ativo) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        body: JSON.stringify({ id, descricao, ativo })
    };
    return fetch(`${process.env.VUE_APP_API_URL}/GrupoProduto/atualizar`, requestOptions)
        .then(handleAuthorization)
        .then(handleOkResponseJson)
        .then(result => {
            return result.data;
        });
}

export function downloadLista() {
	try {
		return axios({
			url: `${process.env.VUE_APP_ROOT_API}/GrupoProduto/downloadGrupos`,
			method: 'GET',
			responseType: 'blob',
			headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
		}).catch(() => {
			return { status: false };
		})
			.then((response) => {
				if (response.status === false)
					return response;
				var fileURL = window.URL.createObjectURL(new Blob([response.data]));
				var fileLink = document.createElement('a');

				fileLink.href = fileURL;
				fileLink.setAttribute('download', 'grupos' + '.xlsx');
				document.body.appendChild(fileLink);

				fileLink.click();
			});
	} catch (e) {
		throw e;
	}
}

export const obterSubGruposProdutoAsync = async () => {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
    };
    return fetch(`${process.env.VUE_APP_API_URL}/GrupoProduto/obterListaSubGrupos`, requestOptions)
        .then(handleAuthorization)
        .then(handleOkResponseJson)
        .then(result => {
            return result.data;
        });
}

export const enviarSubGrupoProdutoAsync = async (descricao, idGrupo) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        body: JSON.stringify({ descricao, idGrupo })
    };
    return fetch(`${process.env.VUE_APP_API_URL}/GrupoProduto/inserirSubGrupo`, requestOptions)
        .then(handleAuthorization)
        .then(handleOkResponseJson)
        .then(result => {
            return result.data;
        });
}

export const editarSubGrupoProdutoAsync = async (id, descricao, idGrupo, ativo) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        body: JSON.stringify({ id, descricao, idGrupo, ativo })
    };
    return fetch(`${process.env.VUE_APP_API_URL}/GrupoProduto/atualizarSubGrupo`, requestOptions)
        .then(handleAuthorization)
        .then(handleOkResponseJson)
        .then(result => {
            return result.data;
        });
}

export function downloadListaSubGrupoProduto() {
	try {
		return axios({
			url: `${process.env.VUE_APP_ROOT_API}/GrupoProduto/downloadSubGrupos`,
			method: 'GET',
			responseType: 'blob',
			headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
		}).catch(() => {
			return { status: false };
		})
			.then((response) => {
				if (response.status === false)
					return response;
				var fileURL = window.URL.createObjectURL(new Blob([response.data]));
				var fileLink = document.createElement('a');

				fileLink.href = fileURL;
				fileLink.setAttribute('download', 'subGrupos' + '.xlsx');
				document.body.appendChild(fileLink);

				fileLink.click();
			});
	} catch (e) {
		throw e;
	}
}
